/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaFileBundleMiniReference,
    MediaFileBundleMiniReferenceFromJSON,
    MediaFileBundleMiniReferenceFromJSONTyped,
    MediaFileBundleMiniReferenceToJSON,
    SubclipReference,
    SubclipReferenceFromJSON,
    SubclipReferenceFromJSONTyped,
    SubclipReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface SubclipClipboardEntry
 */
export interface SubclipClipboardEntry {
    /**
     * 
     * @type {number}
     * @memberof SubclipClipboardEntry
     */
    id: number;
    /**
     * 
     * @type {SubclipReference}
     * @memberof SubclipClipboardEntry
     */
    cut: SubclipReference;
    /**
     * 
     * @type {MediaFileBundleMiniReference}
     * @memberof SubclipClipboardEntry
     */
    bundle?: MediaFileBundleMiniReference;
    /**
     * 
     * @type {Date}
     * @memberof SubclipClipboardEntry
     */
    readonly date: Date;
}

export function SubclipClipboardEntryFromJSON(json: any): SubclipClipboardEntry {
    return SubclipClipboardEntryFromJSONTyped(json, false);
}

export function SubclipClipboardEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubclipClipboardEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'cut': SubclipReferenceFromJSON(json['cut']),
        'bundle': !exists(json, 'bundle') ? undefined : MediaFileBundleMiniReferenceFromJSON(json['bundle']),
        'date': (new Date(json['date'])),
    };
}

export function SubclipClipboardEntryToJSON(value?: SubclipClipboardEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'cut': SubclipReferenceToJSON(value.cut),
        'bundle': MediaFileBundleMiniReferenceToJSON(value.bundle),
    };
}


